import { IDropdown } from '@app/shared/interfaces/dropdown';

export enum SEX {
  'Female' = 1,
  'Male' = 2,
  'Not sure' = 3,
}

export const SEX_DROPDOWN: IDropdown<string>[] = Object.values(SEX)
  .filter((value) => isNaN(Number(value)) === true)
  .map((value) => ({ value: `${SEX[value]}`, label: value } as IDropdown<string>));
